export const FORM_FIELDS = {
  NAME: "name",
  JOB_TITLE: "job_title",
  BIRTH_DATE: "birth_date",
  CITY: "city",
  DESCRIPTION: "description",
};
